import Service 						from "./../../Libs/Service";
import { Layout } 						from "./Layout";
import { Auth } 						from "./Auth";
import { Cluster } 						from "./Cluster";
import _ from "lodash";

// Издатели клиента.
//
// У каждой ноды кластера своя БД, и id издателей на разных нодах могут совпадать, поэтому издатели
// хранятся не одним списком, а разложенными по нодам: serverId -> publisherId -> издатель.
// Номер ноды-источника приходит с сервера вместе с данными (Client/Libs/Service.Socket.js) либо
// берётся из самого издателя (поле server_id). Админ видит издателей всех нод кластера: общий
// список для меню выбора издателя собирает getAllPublishers.
let Publisher = new Service({

	Name: "Publisher",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		}

	},

	Actions: {

		//Сервер сообщает о том, что как минимум один паблишер создан (это нужно для обработки настройки feature-single-publisher)
		'PublisherExists': function(isExists) {

			this.isPublisherExists = !!isExists;

			Broadcast.call("Publishers Exists Changed");

		},

		//Получение текущего издателя (третий аргумент - номер ноды, с которой пришли данные)
		'Publisher': function(publisher, data, size, serverId) {

			//Вторичное соединение с чужой нодой не должно менять выбранного издателя: нода без
			//авторизованного пользователя присылает Publisher: null (Server/Services/Publisher/Publisher.mjs),
			//а это сбросило бы издателя и переключило рабочую ноду клиента на неё
			if (!publisher && serverId && serverId !== this.getPrimaryServerId()) return;

			this.setPublisher(publisher, serverId);

			this.loaded = true;

			if (!this.isSelectedPublisher(publisher)) this.selectPublisher(publisher?.id, serverId);

		},

		//Получение всех издателей для админов: этим же ключом приходит и список своей ноды
		//(основное соединение), и списки остальных нод кластера (вторичные соединения).
		//Номер ноды-источника передаёт слой сокетов (Client/Libs/Service.Socket.js)
		'Publishers': function(publishers, data, size, serverId) {

			_.each(publishers, publisher => {

				this.setPublisher(publisher, serverId);

			});

			this.loaded = true;
			this.LoadedServers[this.resolveServerId(serverId)] = true;

			this.autoSelectPublisher();

			Broadcast.call("Publishers Changed");

			//Список пришёл по вторичному соединению с другой нодой
			if (serverId && serverId !== this.getPrimaryServerId()) Broadcast.call("Server Publishers Loaded", [serverId]);

		},

		// ИИ бюджет паблишера (приходит только паблишер-админам этого паблишера и супер-админам)
		'PublisherAIBudget': function(publisherAIBudget, data, size, serverId) {

			this.getServerMap(this.AIBudgetsByServer, serverId || this.NodeServerId)[publisherAIBudget.id] = publisherAIBudget;

			Broadcast.call("Publisher AI Budget Changed", [publisherAIBudget.id]);

		},

		// Список добавлений денег паблишеру (новые сверху)
		'PublisherAIBudgetLog': function(publisherAIBudgetLog, data, size, serverId) {

			this.getServerMap(this.AIBudgetLogsByServer, serverId || this.NodeServerId)[publisherAIBudgetLog.publisherId] = publisherAIBudgetLog.records;

			Broadcast.call("Publisher AI Budget Changed", [publisherAIBudgetLog.publisherId]);

		},

		'PublisherContacts': function(publisherContacts) {

			_.each(publisherContacts, publisherContact => {

				this.setPublisherContact(publisherContact);

			});

			Broadcast.call("Customer Contacts Changed");

		}

	},

	init() {

		this.loaded = false;

		this.isPublisherExists = null;

		// Текущий издатель
		this.SelectedPublisher = null;

		// Все издатели, разложенные по нодам кластера: serverId -> publisherId -> издатель
		this.Publishers = {};

		// Ноды, которые уже прислали свой список издателей: serverId -> true.
		// Нужно, чтобы не выбрать издателя другой ноды, пока данные нужной ноды ещё не пришли
		this.LoadedServers = {};

		// Обращения клиентов через сайт
		this.PublisherContacts = {};

		// ИИ бюджеты паблишеров (ai_budget, ai_budget_spent, ai_budget_split) и списки добавлений денег
		// паблишерам по id паблишера: карты отдельные для каждой ноды (Client/Libs/Service.js, getServerMap)
		this.AIBudgetsByServer = {};
		this.AIBudgetLogsByServer = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (AIBudgets[publisherId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.AIBudgets = this.getServerMap(this.AIBudgetsByServer, serverId);
		this.AIBudgetLogs = this.getServerMap(this.AIBudgetLogsByServer, serverId);

	},

	// Номер ноды, к которой подключён клиент (нода аккаунта)
	getPrimaryServerId() {

		return Server.getPrimaryServerId();

	},

	// Номер ноды издателя: явный номер имеет приоритет, дальше - номер из самого издателя,
	// а если его нет - номер ноды аккаунта
	resolveServerId(serverId, publisher) {

		return parseInt(serverId, 10) || parseInt(publisher?.server_id, 10) || this.getPrimaryServerId();

	},

	// Номер ноды выбранного издателя: по нему адресованы его креативы, версии и файлы
	getSelectedServerId() {

		return this.SelectedPublisher ? this.SelectedPublisher.server_id : this.getPrimaryServerId();

	},

	// Выбран ли этот издатель сейчас (сравниваем и id, и номер ноды: они совпадают на разных нодах)
	isSelectedPublisher(publisher) {

		return !!publisher && !!this.SelectedPublisher && this.SelectedPublisher.id === publisher.id && this.SelectedPublisher.server_id === publisher.server_id;

	},

	// Издатель по id и номеру его ноды. Без номера ноды ищем по всем нодам
	getPublisher(publisherId, serverId) {

		if (serverId) {

			let publishers = this.Publishers[serverId];

			return publishers ? publishers[publisherId] : undefined;

		}

		return this.findPublisher(publisherId);

	},

	// Поиск издателя по одному id (когда номер ноды неизвестен точно): сначала проверяем указанную
	// ноду (или ноду выбранного издателя), затем ноду аккаунта, затем остальные ноды кластера
	findPublisher(publisherId, serverId) {

		let preferredServers = [serverId || this.getSelectedServerId(), this.getPrimaryServerId()];

		for (let i = 0; preferredServers[i]; i++) {

			let publishers = this.Publishers[preferredServers[i]];

			if (publishers && publishers[publisherId]) return publishers[publisherId];

		}

		let found = null;

		_.each(this.Publishers, publishers => {

			if (!found && publishers[publisherId]) found = publishers[publisherId];

		});

		return found;

	},

	// Общий список издателей всех нод кластера (меню выбора издателя, списки для админов).
	// Издатели хранятся по нодам, поэтому одинаковые id разных нод не смешиваются,
	// а номер своей ноды у каждого издателя есть в поле server_id
	getAllPublishers() {

		return _.flatten(_.map(this.Publishers, publishers => _.values(publishers)));

	},

	// Издатели одной ноды кластера
	getPublishersByServer(serverId) {

		return _.values(this.Publishers[serverId] || {});

	},

	// Нода паблишера по его id: по ней адресуются файлы его сущностей
	// (логотипы, иконки креативов, ассеты, превью)
	getServerIdForPublisher(publisherId) {

		let publisher = this.findPublisher(publisherId);

		if (publisher) return publisher.server_id;

		return this.getSelectedServerId();

	},

	// Адрес логотипа паблишера: файл лежит на ноде этого паблишера, поэтому путь дополняем её адресом
	getLogoUrl(publisher) {

		if (!publisher) return '';

		let version = (publisher['last_activity_time'] || publisher['create_date'] || new Date()).getTime();

		return Auth.getNodeUrlForServer(publisher.server_id, `/Images/Icons/Publishers/${publisher.codename || publisher.id}.png?v=${version}`);

	},

	setPublisher(publisher, serverId) {

		if (!publisher) return;

		serverId = this.resolveServerId(serverId, publisher);

		if (!this.Publishers[serverId]) this.Publishers[serverId] = {};

		let oldPublisher = this.Publishers[serverId][publisher.id];

		this.Publishers[serverId][publisher.id] = publisher;

		if (publisher["last_activity_time"]) publisher["last_activity_time"] = new Date(publisher["last_activity_time"]);

		if (this.isSelectedPublisher(publisher)) {

			this.SelectedPublisher = publisher;

			Broadcast.call("Selected Publisher Data Changed");

		}

		if (oldPublisher) Broadcast.call(`Publisher Changed:${publisher.id}`);

		if (Publisher.SelectedPublisher && Publisher.SelectedPublisher.options && Publisher.SelectedPublisher.options.mainMenu && !Publisher.SelectedPublisher.options.mainMenu.playables && Publisher.SelectedPublisher.options.mainMenu.markers) {

			let i = 0;
			let markerSelected = false;
			let markers = Object.keys(Publisher.SelectedPublisher.options.mainMenu.markers);

			while (!markerSelected && markers.length < i + 1) {

				if (Publisher.SelectedPublisher.options.mainMenu.markers[Object.keys(Publisher.SelectedPublisher.options.mainMenu.markers)[i]]) {

					console.log(markers[i]);

					Layout.setPage('marker', {markers: [markers[i]]});

					markerSelected = true;

				} else {

					i++;

				}

			}

		}

	},

	// Выбор издателя: номер ноды можно не передавать - тогда он определяется по самому издателю
	selectPublisher(publisher_id, serverId) {

		let publisher = serverId ? this.getPublisher(publisher_id, serverId) : this.findPublisher(publisher_id);

		serverId = publisher ? publisher.server_id : this.resolveServerId(serverId);

		// Нода выбранного паблишера: по ней адресуются его креативы, версии и файлы
		Server.setDefaultServerId(serverId);

		// Все http ссылки дашборда (файлы, превью, ассеты) тоже строятся на ноду этого паблишера:
		// его данные живут только на ней (Documents/Cluster.txt)
		Auth.applyWorkingServerAddress(serverId);

		// Переход клиента на другую ноду: подменяем активные карты сервисов картами этой ноды
		// (Cluster Working Node Changed). Кэши не очищаются - данные каждой ноды остаются в её
		// картах (Client/Libs/Service.js, getServerMap), поэтому при возвращении всё открывается сразу
		Cluster.useServer(serverId);

		this.SelectedPublisher = publisher || null;

		Layout.setPublisher(publisher_id);

		Broadcast.call("Selected Publisher Changed", [this.SelectedPublisher]);

		if (!publisher) return;

		window.localStorage.setItem('selected-publisher-id', publisher_id);

		// Номер ноды храним рядом с id: на разных нодах id издателей могут совпадать
		window.localStorage.setItem('selected-publisher-server-id', serverId);

	},

	// Смена паблишера пользователем (меню паблишеров, список паблишеров и т.д.).
	// Отдельный метод оставлен точкой входа для интерфейса: сам выбор и смена ноды - в selectPublisher
	switchPublisher(publisher) {

		if (!publisher) return;

		this.selectPublisher(publisher.id, publisher.server_id);

	},

	// Нода уже прислала свой список издателей
	isPublisherServerLoaded(serverId) {

		return !!this.LoadedServers[serverId || this.getPrimaryServerId()];

	},

	autoSelectPublisher() {

		//Отменяем сброс паблишера при переподключении к серверу
		if (this.SelectedPublisher && this.getPublisher(this.SelectedPublisher.id, this.SelectedPublisher.server_id)) return;

		let publisher_id = parseInt(window.localStorage.getItem('selected-publisher-id')),
			server_id = parseInt(window.localStorage.getItem('selected-publisher-server-id'));

		if (publisher_id) {

			//Издатель хранится вместе с номером ноды: на разных нодах id издателей могут совпадать
			let stored = server_id ? this.getPublisher(publisher_id, server_id) : this.findPublisher(publisher_id);

			if (stored) return this.selectPublisher(stored.id, stored.server_id);

			//Нода сохранённого издателя ещё не прислала свой список - ждём её данные (они придут
			//по вторичному соединению). Иначе выбрали бы издателя другой ноды и смешали бы данные
			if (server_id && server_id !== this.getPrimaryServerId() && Metadata.Servers[server_id] && !this.isPublisherServerLoaded(server_id)) return;

		}

		//По умолчанию выбираем издателя ноды аккаунта
		let primaryServerId = this.getPrimaryServerId(),
			primaryPublishers = this.getPublishersByServer(primaryServerId);

		if (primaryPublishers.length) return this.selectPublisher(primaryPublishers[0].id, primaryServerId);

		//Фолбэк: первый издатель из тех, что успели прийти с нод кластера
		let publishers = this.getAllPublishers();

		if (publishers.length) this.selectPublisher(publishers[0].id, publishers[0].server_id);

	},

	setPublisherContact(publisherContact) {

		if (publisherContact) {

			let oldPublisherContact = this.PublisherContacts[publisherContact.id];

			this.PublisherContacts[publisherContact.id] = publisherContact;

			if (oldPublisherContact) Broadcast.call(`Publisher Contact Changed:${publisherContact.id}`);

		}

	},

	getActivePublisherContactsCount() {

		return _.filter(this.PublisherContacts, publisherContact => publisherContact.active).length;

	},

	getOrderedPublishersList(searchFilter) {

		searchFilter = searchFilter.trim().toLowerCase();

		let publishers = this.getAllPublishers(),
			now = Date.now();

		if (searchFilter) publishers = _.filter(publishers, p => p.title.toLowerCase().indexOf(searchFilter) > -1);
		else publishers = _.filter(publishers, p => (p.active && (now - p["last_activity_time"] < 6 * 30 * 24 * 3600 * 1000)) || this.isInFavorites(p)); // Если не прописан фильтр исключим тех, у кого нет активности пол года

		let result = [];

		// Сначала добавляем избранные паблишеры сортируя по имени
		result.push(..._.orderBy(_.filter(publishers, p => this.isInFavorites(p)), 'title', 'asc'));

		// И удалим их из списка выбранных
		_.remove(publishers, p => this.isInFavorites(p));

		// Затем добавим активных сортируя по имени
		result.push(..._.orderBy(_.filter(publishers, p => p.active), 'title', 'asc'));

		// Затем добавим неактивных сортируя по имени
		result.push(..._.orderBy(_.filter(publishers, p => !p.active), 'title', 'asc'));

		return result;

	},

	isInFavorites(publisher) {

		return User.currentUser?.options?.favoritePublishers && User.currentUser.options.favoritePublishers.includes(publisher.id);

	},

	// Является ли текущий пользователь паблишер-админом указанного паблишера
	isPublisherAdmin(publisherId) {

		return !!(User.currentUser?.Tags['publisher-admin'] && User.currentUser['publisher_id'] === publisherId);

	},

	// Проверяем активирован ли указаный релиз для текущего паблишера
	isReleaseActive(releaseCodename) {

		return Publisher.SelectedPublisher?.options?.Releases?.[releaseCodename] === true || (Publisher.SelectedPublisher?.options?.Releases?.[releaseCodename] !== false && Metadata.ReleasesByCodename?.[releaseCodename]?.["options"]?.["enabledByDefault"]);

	}

});

window.Publisher = Publisher;

export { Publisher }
